import { FC, HTMLAttributes, MouseEvent } from "react";
import { _ } from "../utils/helpers";
import { rumba, VENUE_WHATSAPP_NUMBERS } from "../utils/symbols";
import { Icon } from "./Icon";

interface HelpButtonProps {
    className?: string
}

export const HelpButton: FC<HelpButtonProps> = ({className}) => {

    const onWhatsAppSupportClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        window.open(`https://wa.me/${VENUE_WHATSAPP_NUMBERS[rumba.venueId]}/?text=Hola%20necesito%20ayuda%20sobre%20mi%20reserva`)
    }

    const onProblemsWithYourPurchseClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        window.open((window as any).contactPage)
    }

    return (
        <>
        <button 
            className={`button r3 action-1 b-0 bs-1 df jcfs aic soft text outline-shadow ${className ?? ''}`}
            onClick={onProblemsWithYourPurchseClick}
            aria-label={_('1da_probl__')}
        >
            <Icon icon="support" aria-hidden="true"/>
            <p className="text s18-500 nw soft" aria-hidden="true">{_('1da_probl__')}</p>
        </button>
        <button 
            className={`button r3 action-3 b-0 bs-1 df jcfs aic soft text outline-shadow ${className ?? ''}`}
            onClick={onWhatsAppSupportClick}
            aria-label={_('1da_write__')}
        >
            <Icon icon="whatsapp" aria-hidden="true"/>
            <p className="text s18-500 nw soft" aria-hidden="true">{_('1da_write__')}</p>
        </button>
        </>
    )
}
